export default "__VITE_ASSET__4437fed9__"